var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link.type === 'internal')?_c('nuxt-link',{attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.link.url,"target":_vm.link.target}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }